export default __webpack_public_path__ + "static/media/maximum_bet_100$.e8e02af5.mp3";